import React from "react";
import { format, getTime } from "date-fns";

export function JourneyTime({
  expected,
  estimated,
}: {
  expected: Date;
  estimated: Date | null;
}) {
  if (estimated && getTime(estimated) !== getTime(expected)) {
    return (
      <>
        <del>{format(expected, "HH:mm")}</del>
        <ins>{format(estimated, "HH:mm")}</ins>
      </>
    );
  } else {
    return format(expected, "HH:mm");
  }
}
